module.exports = __webpack_public_path__ + "img/sfjdzx_img.83630b78.png";